module.exports = __webpack_public_path__ + "static/img_0912-4e798b1571b0954cadbec18c9fe16d3d.webp";